import axios from "axios";

var api = {
    url: 'https://uren-mlbv.vps8.tableaux.nl/module/restapi/',
    token: '$2a$08$Vo7E.UsSpG.udcBuvDhfxOLPXgGk51BhWIgwnvDNzKFNHpvvaR4Z6',
    entity: '',
    type: '',
    data: {},
    set: function(method = 'GET',entity = '',data = {}){
        api.type = method;
        api.entity = entity;
        api.data = data;

        return api;
    },
    execute: function(){
        return new Promise(function(resolve, reject) {3
            axios({
                method: api.type,
                url: api.url+api.entity,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': 'Bearer '+api.token,
                },
                data: api.data
            }).then((response) => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
};

export default api;